import React, { useState } from "react";
import styles from "./exchange.module.scss";
import GenericInput from "../common/GenericInput";
import GenericButton from "../common/genericButton";
import InfoTopBar from "../common/InfoTopBar/InfoTopBar";
import LoginSignUp from "../common/LoginSignUp/LoginSignUp";
const options = ["euro", "Dollar", "euro", "Dollar", "euro"];

const Exchange = () => {
  const [selected, setSelected] = useState("Dollar");
  const [isActive, setIsActive] = useState(false);
  const [selectOption , setSelectOption] = useState("Euro");
  const [isSelectActive , setIsSelectActive]= useState(false)
  
  const changeHandler = () => {};
  return (
    <div className={styles.wrapper}>
      <InfoTopBar
        heading="Exchange"
        info="Use below interface to exchange two assets with each other."
        divider={true}
      >
       
  {/* <LoginSignUp /> */}
      </InfoTopBar>

      <div className={styles.container}>
        <div className={styles.left}>
          <div className={styles.coinCard}>
            <div
              className={styles.dropdown}
              style={{ border: "1px solid #008ce7" }}
            >
              <img src={"/assets/doge-coin.svg"} />
              <div
                className={styles.dropdownbtn}
                style={{ color: "#008ce7" }}
                onClick={(e) => setIsActive(!isActive)}
              >
                {selected}
              </div>
              <img src={"/assets/dropdown-arrow.svg"} />
              {isActive && (
                <div className={styles.dropdowncontent}>
                  {options.map((option) => (
                    <div
                      onClick={(e) => {
                        setSelected(option);
                        setIsActive(false);
                      }}
                      className={styles.dropdownitems}
                    >
                      {option}
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className={styles.amountWrapper}>
              <div className={styles.amountLeft}>
                <div className={styles.text}>Your Balance</div>
                <span className={styles.balanceText}>3.0611162 DASH</span>
              </div>
              <div className={styles.amountRight}>
                <div className={styles.text}>Auto Amount</div>
                <div className={styles.buttonsDiv}>
                  <div
                    className={styles.button}
                    style={{
                      background: "#008ce7",
                      border: "1px solid #008ce7",
                    }}
                  >
                    MAX
                  </div>
                  <div
                    className={styles.button}
                    style={{
                      background: "#008ce7",
                      border: "1px solid #008ce7",
                    }}
                  >
                   HALF
                  </div>
                  <div
                    className={styles.button}
                    style={{
                      background: "#008ce7",
                      border: "1px solid #008ce7",
                    }}
                  >
                    MIN
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.valueWrapper}>
              <div className={styles.valueLeft}>
                <div className={styles.text}>Value</div>
                <span className={styles.balanceText}>3.0611162 DASH</span>
              </div>
              <div className={styles.valueRight}>
                <div className={styles.fieldWrapper}>
                  <GenericInput
                    label={"DASH"}
                    placeholder="Enter amount in DASH"
                    type="text"
                    withRightIcon={false}
                    name="email"
                    onChange={changeHandler} 
                    className={styles.input}
                  />
                  <GenericInput
                    label={"USD"}
                    placeholder="Enter amount in USD"
                    type="text"
                    withRightIcon={false}
                    name="email"
                    onChange={changeHandler}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className={styles.exchangeIcon}>
            <img src={"/assets/exchange-icon.svg"} />
          </div>
          <div
            className={styles.coinCard}
            style={{ bottom: "0px", top: "-25px" }}
          >
            <div
              className={styles.dropdown}
              style={{ border: "1px solid #f7931a" }}
            >
              <img src={"/assets/bitcoin.svg"} />
              <div
                className={styles.dropdownbtn}
                style={{ color: "#f7931a" }}
                onClick={(e) => setIsSelectActive(!isSelectActive)}
              >
                {selectOption}
              </div>
              <img src={"/assets/dropdown-arrow.svg"} />
              {isSelectActive && (
                <div className={styles.dropdowncontent}>
                  {options.map((option) => (
                    <div
                      onClick={(e) => {
                        setSelectOption(option);
                        setIsSelectActive(false);
                      }}
                      className={styles.dropdownitems}
                    >
                      {option}
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className={styles.amountWrapper}>
              <div className={styles.amountLeft}>
                <div className={styles.text}>Your Balance</div>
                <span className={styles.balanceText}>3.0611162 DASH</span>
              </div>
              <div className={styles.amountRight}>
                <div className={styles.text}>Auto Amount</div>
                <div className={styles.buttonsDiv}>
                  <div
                    className={styles.button}
                    style={{
                      background: "#f7931a",
                      border: "1px solid #f7931a",
                    }}
                  >
                    MAX
                  </div>
                  <div
                    className={styles.button}
                    style={{
                      background: "#f7931a",
                      border: "1px solid #f7931a",
                    }}
                  >
                    HALF
                  </div>
                  <div
                    className={styles.button}
                    style={{
                      background: "#f7931a",
                      border: "1px solid #f7931a",
                    }}
                  >
                    MIN
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.valueWrapper}>
              <div className={styles.valueLeft}>
                <div className={styles.text}>Value</div>
                <span className={styles.balanceText}>3.0611162 DASH</span>
              </div>
              <div className={styles.valueRight}>
                <div className={styles.fieldWrapper}>
                  <GenericInput
                    label={"DASH"}
                    placeholder="Enter amount in DASH"
                    type="text"
                    withRightIcon={false}
                    name="email"
                    onChange={changeHandler}
                  />
                  <GenericInput
                    label={"USD"}
                    placeholder="Enter amount in USD"
                    type="text"
                    withRightIcon={false}
                    name="email"
                    onChange={changeHandler}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.right}>
          <div className={styles.rightWrapper}>
            <div className={styles.heading}>Exchange Calculations</div>
            <p className={styles.text}>
              Calculations based on your exchange selection.
            </p>
            <div className={styles.coinInfo}>
              <p className={styles.text}>Your Are Exchanging</p>
              <div className={styles.data}>
                <div className={styles.dataWrapper}>
                  <div className={styles.icon}>
                    <img src={"/assets/doge-coin.svg"} />
                  </div>
                  <div className={styles.name} style={{ color: "#008ce7" }}>
                    {" "}
                    Dash
                  </div>
                </div>

                <div className={styles.amount}>
                  <div className={styles.coin}> 0.00 DASH</div>
                  <div className={styles.cash}> 0.00 USD</div>
                </div>
              </div>
            </div>
            <div className={styles.coinInfo}>
              <p className={styles.text}>You Will Receive</p>
              <div className={styles.data}>
                <div className={styles.dataWrapper}>
                  <div className={styles.icon}>
                    <img src={"/assets/bitcoin.svg"} />
                  </div>
                  <div className={styles.name} style={{ color: "#f7931a" }}>
                    {" "}
                    Bitcoin
                  </div>
                </div>

                <div className={styles.amount}>
                  <div className={styles.coin}> 0.00 BTC</div>
                  <div className={styles.cash}> 0.00 USD</div>
                </div>
              </div>
            </div>
            <div className={styles.line}></div>
            <div className={styles.exchangeAccept}>
              <div className={styles.buttonWrapper}>
                <GenericButton title={"Exchange"} />
              </div>
              <div className={styles.coinText}> 1 DASH = 0.0010234451</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Exchange;
